/* South Miami appointment contact clicks; existing Shopify consent-managed pixel. */
(function () {
  'use strict';
  if (!/^(www\.)?geebeauty\.com$/.test(location.hostname) || window.__geeSouthMiamiContactV1) return;
  if (location.pathname !== '/pages/studio/south-miami') return;
  window.__geeSouthMiamiContactV1 = true;
  document.addEventListener('click', function (event) {
    if (!event.isTrusted || event.button !== 0) return;
    var node = event.target instanceof Element ? event.target : event.target.parentElement;
    var link = node && node.closest('#appointment-request a[data-studio="south_miami"][data-contact-method]');
    if (!link) return;
    var method = link.getAttribute('data-contact-method');
    var expected = { phone: 'tel:+13059005950', sms: 'sms:+17862217986', email: 'mailto:southmiami@geebeauty.com' };
    if (!expected[method] || link.getAttribute('href') !== expected[method]) return;
    if (!window.Shopify || !window.Shopify.analytics || typeof window.Shopify.analytics.publish !== 'function') return;
    var environment = window.Shopify.theme && window.Shopify.theme.role === 'main' ? 'live' : 'preview';
    var params = {
      studio: 'south_miami', contact_method: method, interaction_type: 'appointment_contact',
      page_path: location.pathname, page_location: location.origin + location.pathname,
      market: 'us', tracking_version: 'south_miami_contact_v1', tracking_environment: environment
    };
    var query = new URLSearchParams(location.search);
    if (query.get('utm_source') === 'google' && query.get('utm_medium') === 'organic' &&
        query.get('utm_campaign') === 'gbp_south_miami' && query.get('utm_content') === 'appointment_request') {
      params.entry_link = 'gbp_south_miami_appointment_request';
    }
    if (environment === 'preview') params.debug_mode = true;
    try {
      var result = window.Shopify.analytics.publish('studio_booking_click', params);
      if (result && typeof result.catch === 'function') result.catch(function () {});
    } catch (_) { /* Navigation must work even when analytics is unavailable. */ }
  }, true);
})();
